import { Phone, FileText } from "lucide-react";
import { GARAGE } from "../../lib/constants";
import { useDevis } from "./DevisForm";

export default function MobileBottomBar() {
  const { openDevis } = useDevis();
  return (
    <div
      data-testid="barre-mobile-basse"
      className="fixed bottom-0 left-0 right-0 z-50 lg:hidden grid grid-cols-2 shadow-[0_-4px_12px_rgba(0,0,0,0.25)]"
    >
      <a
        data-testid="barre-mobile-appeler"
        href={`tel:${GARAGE.telephoneLien}`}
        className="flex items-center justify-center gap-2 bg-brand-dark text-white font-heading font-semibold uppercase tracking-wider text-lg py-4 min-h-[56px] active:bg-black transition-colors"
      >
        <Phone size={20} aria-hidden="true" />
        Appeler
      </a>
      <button
        data-testid="barre-mobile-devis"
        onClick={() => openDevis()}
        className="flex items-center justify-center gap-2 bg-brand-red text-white font-heading font-semibold uppercase tracking-wider text-lg py-4 min-h-[56px] active:bg-brand-redhover transition-colors"
      >
        <FileText size={20} aria-hidden="true" />
        Demander un devis
      </button>
    </div>
  );
}
